export const PROGRESS_BAR_IS_NOT_OPEN_ERROR = 'Progress Bar Panel is not open';
